import React from 'react';
import { Container } from 'react-bootstrap';
import Head from 'next/head';

export default function HttpError404() {
  return (
    <>
      <Head>
        <title>AboutCar - Página não encontrada!</title>
      </Head>
      <Container className="error 404">
        <h1 className="text-center">
          <span>Página não encontrada!</span>
        </h1>
        <div className="header-3 text-center">
          <span>Talvez queira acessar algum dos links acima.</span>
          <br />
          <small>Ou pode entrar em contato conosco através de nossos canais de atendimento.</small>
        </div>
      </Container>
    </>
  );
}
